import { render, staticRenderFns } from "./QRAnnouncement.vue?vue&type=template&id=79d3ee7c&scoped=true&"
import script from "./QRAnnouncement.vue?vue&type=script&lang=js&"
export * from "./QRAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3ee7c",
  null
  
)

export default component.exports